/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VersionActionType = {
    SimulationCreated: 'SimulationCreated',
    StatusChanged: 'StatusChanged',
    Published: 'Published',
    OwnershipChanged: 'OwnershipChanged',
    ManualSnapshot: 'ManualSnapshot',
    VersionRestored: 'VersionRestored'
} as const;
export type VersionActionType = typeof VersionActionType[keyof typeof VersionActionType];


export function instanceOfVersionActionType(value: any): boolean {
    for (const key in VersionActionType) {
        if (Object.prototype.hasOwnProperty.call(VersionActionType, key)) {
            if (VersionActionType[key as keyof typeof VersionActionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VersionActionTypeFromJSON(json: any): VersionActionType {
    return VersionActionTypeFromJSONTyped(json, false);
}

export function VersionActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionActionType {
    return json as VersionActionType;
}

export function VersionActionTypeToJSON(value?: VersionActionType | null): any {
    return value as any;
}

export function VersionActionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): VersionActionType {
    return value as VersionActionType;
}

